module.exports = __webpack_public_path__ + "static/userRequestAppointment-bfca65e5736925e9fee13cdb362560af.gif";